﻿import axios from "axios";
/*import core from './core'*/

export default {
    data() {
        return {
            wishlist: window.wishlist,
            isLoading:false
        }
    },
    created: function () {
    },
    methods: {
        isWishlistItem: function (productId) {
            for (var i = 0; i < this.wishlist.length; i++) {
                if (this.wishlist[i].productId == productId) {
                    return true;
                }
            }
            return false;
        },
        toggleWishlistItem: function (productId) {
            var vm = this;
            vm.isLoading = true;
            var wishlistAction = this.isWishlistItem(productId) ? "remove" : "add";
            $.ajax({
                url: vm.URLPrefix + '/wishlist/ToggleWishlistItem?itemAction=' + wishlistAction + '&productId=' + productId,
                success: function (wishlist) {
                    vm.wishlist = wishlist;
                    vm.isLoading = false;
                }
            });
        },
        getHeartIcon: function (productId, srcPrefix) {
            var iconSrc = srcPrefix != undefined && srcPrefix != null && srcPrefix != "" ? srcPrefix : "/img/";
            if (this.isWishlistItem(productId))
                iconSrc += "heart-icon-full.svg";
            else
                iconSrc += "heart-icon.svg";
            return iconSrc;
        }
    },
    watch: {
    },
    computed: {
    }
};
